import React, { FC } from 'react';
import styled from 'styled-components';
import App from '../../../models/app';

import { translations } from 'i18n';
import { BannerContainer } from '../ImageContainer/BannerContainer';
import { fontSemibold } from '../../../themes';
import { LinkAction } from '../LinkAction/index';
import { Link } from '../Common';

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BannerInfoContainer = styled.div`
  display: flex;
  margin: 20px 10px;
`;

const BannerDiv = styled.div`
  width: 75px;
  height: 75px;
  flex-shrink: 0;

  background: #FFFFFF;
  border: 2px solid #E7E9EA;
  box-sizing: border-box;
  border-radius: 14px;
`;

const CenterContent = styled.div`
  flex-grow: 1;
  min-width: 0px;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Name = styled.div`
  font-family: ${fontSemibold};
  padding: 3px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DeveloperName = styled.div`
  font-family: SF Pro Text;
  font-size: 16px;
  line-height: 24px;

  letter-spacing: -0.32px;

  color: #707C83;
  padding: 3px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ViewAppContainer = styled.div`
  border-top: 1px solid #E7E9EA;
`;

const LinkContainer = styled(LinkAction)``;

const ArrowContainer = styled.div`
  display: flex;
`;

const {
  viewApp
} = translations.page.App.Details;

interface ParentAppSectionProps {
  app: App;
}

const ParentAppSection: FC<ParentAppSectionProps> = (props) => {
  const { app } = props;
  const screenshot = app.icon;

  return (
    <SectionContainer>
      <Link
        to={`/v2/app/${app.id}`}
        pageDirection='FORWARD'
        id={'tiles-parent-app'}
        aria-label={'tiles-parent-app'}
      >
        <BannerInfoContainer>
          <BannerDiv>
            <BannerContainer
              containerAttr={{
                width: screenshot.width,
                height: screenshot.height,
              } as any}
              imageAttr={{
                src: screenshot.uri,
                alt: app.name,
              }}
            />
          </BannerDiv>
          <CenterContent>
            <Name>{app.name}</Name>
            <DeveloperName>{app.developer.name}</DeveloperName>
          </CenterContent>
        </BannerInfoContainer>
      </Link>
    </SectionContainer>
  )
}

export default ParentAppSection;
